import {useTranslation} from 'react-i18next';
import * as css from './SubscriptionTableHeader.css';

function SubscriptionTableHeader() {
    const {t} = useTranslation('realtime');

    return (
        <css.header>
            <css.nameCell>{t('seriesName')}</css.nameCell>
            <css.cell>{t('eventsInSeries')}</css.cell>
            <css.cell>{t('activeEvents')}</css.cell>
            <css.cell>{t('pastEvents')}</css.cell>
            <css.cell>{t('salesPerPlan')}</css.cell>
            <css.cell>{t('remainingTickets')}</css.cell>
            <css.cell>{t('realizations')}</css.cell>
        </css.header>
    );
}

export default SubscriptionTableHeader;

